module.exports = __webpack_public_path__ + "static/media/light-04.d71f9953.jpg";